var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAppsSharp2Icon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.64286 7H1.35714C1.1599 7 1 7.3198 1 7.71429V16.2857C1 16.6802 1.1599 17 1.35714 17H5.64286C5.8401 17 6 16.6802 6 16.2857V7.71429C6 7.3198 5.8401 7 5.64286 7Z",
    fill: "#CA5050"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2857 2H7.71429C7.3198 2 7 2.63959 7 3.42857V20.5714C7 21.3604 7.3198 22 7.71429 22H16.2857C16.6802 22 17 21.3604 17 20.5714V3.42857C17 2.63959 16.6802 2 16.2857 2Z",
    fill: "#CA5050"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6429 7H18.3571C18.1599 7 18 7.3198 18 7.71429V16.2857C18 16.6802 18.1599 17 18.3571 17H22.6429C22.8401 17 23 16.6802 23 16.2857V7.71429C23 7.3198 22.8401 7 22.6429 7Z",
    fill: "#CA5050"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppsSharp2Icon);
export default __webpack_public_path__ + "static/media/apps-sharp2-icon.4dcafcfa477412262ce819e103987df9.svg";
export { ForwardRef as ReactComponent };